import { useCallback, useState } from 'react';

export default function useControllableOpen(
  isOpen?: boolean,
  onOpenChange?: (open: boolean) => void
): [boolean, (next: boolean | ((prev: boolean) => boolean)) => void] {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);

  const controlled = typeof isOpen === 'boolean';
  const open = controlled ? isOpen : uncontrolledOpen;

  const setOpen = useCallback(
    (next: boolean | ((prev: boolean) => boolean)) => {
      const resolved = typeof next === 'function' ? next(open) : next;
      if (!controlled) setUncontrolledOpen(resolved);
      onOpenChange?.(resolved);
    },
    [controlled, onOpenChange, open]
  );

  return [open, setOpen];
}
